export function arrayContainsItemFromAnother(
  array1: unknown[],
  array2: unknown[]
) {
  return array1.some((r) => array2.includes(r))
}

export function isEmpty(array?: unknown) {
  return array && Array.isArray(array) && array.length === 0
}

export function isInArray<
  ArrayItem extends Record<string, unknown> = Record<string, unknown>,
>(array: ArrayItem[], objectKey: keyof ArrayItem, key: string) {
  return array.some((item) => item[objectKey] === key)
}
